export { FooterBadges } from './FooterBadges'
